import { RotationEvaluationAssignment } from "./API"

const STORAGE_KEY = "submittedRotationEvaluationAssignments"

const getSubmittedAssignmentIds = () => {
  try {
    const rawValue = localStorage.getItem(STORAGE_KEY)
    const parsedValue = rawValue ? JSON.parse(rawValue) : []
    if (!Array.isArray(parsedValue)) {
      return []
    }
    return parsedValue
      .map((value) => Number(value))
      .filter((value) => Number.isFinite(value))
  } catch (error) {
    localStorage.removeItem(STORAGE_KEY)
    return []
  }
}

export const markRotationEvaluationSubmitted = (assignmentId: number) => {
  const submittedIds = new Set(getSubmittedAssignmentIds())
  submittedIds.add(assignmentId)
  localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(submittedIds)))
}

export const filterPendingRotationEvaluations = (
  assignments: RotationEvaluationAssignment[]
) => {
  const submittedIds = new Set(getSubmittedAssignmentIds())
  return assignments.filter((assignment) => !submittedIds.has(assignment.id))
}
